import { render, staticRenderFns } from "./CustomerFree.vue?vue&type=template&id=5d8d4209&"
import script from "./CustomerFree.vue?vue&type=script&lang=js&"
export * from "./CustomerFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports